export default function eventParts(api) {
    return api && api.provideCall && api.provideCall('requestEventParts', 'cancelEventPartsRequest', {
            // topic to request
            rpcName: '/sports#eventParts',

            parseParams: ({lang = 'en'}) => ({lang}),

            // validation occurs before parsing
            validateResponse: (data) => data && data.kwargs,
            parseResponse: data => (!data && []) || (data.kwargs && data.kwargs.records) || (data && data.kwargs),
        });
}



// WEBPACK FOOTER //
// ./src/OMFECore/enhanced-webapi/api-sports/rpc-event-parts.js